import styled from "styled-components";

const ButtonGroup = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export default ButtonGroup;
